module.exports = __webpack_public_path__ + "884ea0a154d55a220b2e31b9af80ad8a.svg";